<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-group  class="col-md-6">
          <label for="name" class="text-capitalize"> روز شروع : </label>
          <b-form-input class="my-custom-editable-input1" type="text" />
          <date-picker
              auto-submit
              clearable
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jDD"
              v-model="start_date"
              custom-input=".my-custom-editable-input1"
          />
        </b-form-group>
        <b-form-group  class="col-md-6">
          <label for="name" class="text-capitalize"> روز پایان : </label>
          <b-form-input class="my-custom-editable-input2" type="text" />
          <date-picker
              auto-submit
              clearable
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jDD"
              v-model="end_date"
              custom-input=".my-custom-editable-input2"
          />
        </b-form-group>
        <b-button variant="primary" @click="getStatisticsOrder()">
          <span class="text-capitalize">
              جست و جو
            </span>
        </b-button>
      </b-col>
      <div class="bg-white p-2 rounded-lg shadow-sm" v-if="statisticsOrder">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار  درخواست های رزرو
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_total_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست موفق  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_total_paid}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد مهمان  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_total_guest}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(statisticsOrder.orders_total_prices_paid)}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1" v-if="statisticsOrder.user_with_most_orders">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success" v-if="statisticsOrder.user_with_most_orders">
              {{statisticsOrder.user_with_most_orders.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary" v-if="statisticsOrder.user_with_most_orders">
              {{statisticsOrder.user_with_most_orders.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success" v-if="statisticsOrder.user_with_most_orders">
              {{statisticsOrder.user_with_most_orders.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1" v-if="statisticsOrder.user_with_most_paid_orders">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success" v-if="statisticsOrder.user_with_most_paid_orders">
              {{statisticsOrder.user_with_most_paid_orders.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary" v-if="statisticsOrder.user_with_most_paid_orders">
              {{statisticsOrder.user_with_most_paid_orders.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success" v-if="statisticsOrder.user_with_most_paid_orders">
              {{statisticsOrder.user_with_most_paid_orders.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1" v-if="statisticsOrder.most_ordered_product">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info" v-if="statisticsOrder.most_ordered_product">
              {{statisticsOrder.most_ordered_product.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info" v-if="statisticsOrder.most_ordered_product">
              {{statisticsOrder.most_ordered_product.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1" v-if="statisticsOrder.most_ordered_paid_product">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها رزروهای موفق در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info" v-if="statisticsOrder.most_ordered_paid_product">
              {{statisticsOrder.most_ordered_paid_product.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info" v-if="statisticsOrder.most_ordered_paid_product">
              {{statisticsOrder.most_ordered_paid_product.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
      </div>
    </b-row>

<!--    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار 30 روز گذشته، درخواست های رزرو
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست موفق  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_paid}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد مهمان  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_guest}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(statisticsOrder.orders_last_month_total_prices_paid)}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_month_days.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_days.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها رزروهای موفق در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_paid.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
      </div>
    </b-row>-->

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    BBadge,
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      end_date:'',
      start_date:'',
      perPage: 10,
      page: 1,
      statisticsOrder: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatisticsOrder();
  },

  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    async getStatisticsOrder() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/reports_orders2",
        params: {
          start_date: this.start_date,
          end_date: this.end_date
        }

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statisticsOrder = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
